/**
 * useSquadPreview - whether the brother you act as is aiming at Enter or Challenge (Squad Mode, 2026-10-24), so the
 * map previews the support ring and threads he would have.
 *
 * A tiny store outside React state, as `utils/viewerPrefs` is: the strip's buttons and the drum's cursor set it, and
 * only the map's support layer reads it - a hover re-renders nothing else. Several sources may hold it at once (the
 * drum's cursor on Enter while the pointer rests on the strip's Challenge); it is on while any of them is.
 *
 * @returns true while any source previews
 */
import { useSyncExternalStore } from 'react';

const holding = new Set<string>();
const listeners = new Set<() => void>();
let on = false;

/** Say whether `source` (the strip, the drum) previews now. */
export function setSquadPreview(source: string, previewing: boolean): void {
  if (previewing) holding.add(source);
  else holding.delete(source);
  if (on === holding.size > 0) return;
  on = holding.size > 0;
  listeners.forEach((l) => l());
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

const now = () => on;

export default function useSquadPreview(): boolean {
  return useSyncExternalStore(subscribe, now, now);
}
